import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {getAdminProfileChanges} from 'src/openapi/admin/apis/AdminProfileChangesApi';
import {useAppDispatch} from 'src/store/hooks';

import {userRoleAuditLogStateSelector} from '../slices/user-role-audit-log-state.slice';
import {
    userRoleAuditLogActions,
    userRoleAuditLogDataSelector,
    userRoleAuditLogResultSelector,
} from '../slices/user-role-audit-log.slice';

import type {UserRoleAuditLogCacheKeys} from '../typedef';
import type {AdminChangeHistory} from 'src/openapi/admin/models/AdminChangeHistory';


type Props = {
    userId: number,
};

export const useGetUserRoleAuditLog = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback((cacheKeys: UserRoleAuditLogCacheKeys) => apiDispatch(getAdminProfileChanges({
        pageNumber: cacheKeys.pagination.currentPage,
        pageSize: cacheKeys.pagination.pageSize,
        adminId: userId,
    })), [userId, apiDispatch]);

    const setLoadedData = useCallback((
        response: AdminChangeHistory,
        cacheKeys: UserRoleAuditLogCacheKeys,
    ) => {
        dispatch(userRoleAuditLogActions.onSuccess(({
            cacheKeys,
            totalCount: response.totalCount,
            data: response.eventList,
        })));
    }, [dispatch]);

    return useCachedTable({
        dataSelector: userRoleAuditLogDataSelector,
        stateSelector: userRoleAuditLogStateSelector,
        resultSelector: userRoleAuditLogResultSelector,
        actions: userRoleAuditLogActions,
        getAction,
        onSuccessLoad: setLoadedData,
        shouldClearOnUnmount: true,
    });
};
